module.exports = __webpack_public_path__ + "static/img/hua12.ff3e764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua12.png
// module id = Vexm
// module chunks = 22